import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { CoordinatorManageSignupsPageForShift } from './CoordinatorManageSignupsPageForShift';
import { featureIsEnabled, useFeatures } from '../../hooks/features';
import { MANAGE_SIGNUPS_ON_SHIFT_LEVEL } from '../../utils/constants';
import { ActivitySidebar } from '../myActivity/sideNav';

export function CoordinatorManageSignupsPage() {
  const [searchParams] = useSearchParams();
  const features = useFeatures();
  const urlFeatures = searchParams.get('features');
  const shiftId = searchParams.get('shiftId');
  const volunteerActivityUrl = `/my-activity${urlFeatures ? '?features=' + urlFeatures : ''}`;

  const navigation = <ActivitySidebar baseUrl={volunteerActivityUrl} />;

  if (shiftId && featureIsEnabled(MANAGE_SIGNUPS_ON_SHIFT_LEVEL, features, searchParams)) {
    return <CoordinatorManageSignupsPageForShift navigation={navigation} />;
  }
  // TODO support managing signups for event cross all shifts : https://issues.amazon.com/issues/cce-6410
  return null;
}
